"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicChannelVideosService = void 0;
const tslib_1 = require("tslib");
const channel_videos_1 = require("@wix/wix-vod-api-site-based/dist/src/public/services/channel-videos/channel-videos");
const to_error_1 = require("../../parsers/to-error");
const video_item_1 = require("../../parsers/video-item");
class PublicChannelVideosService {
    constructor(httpClient, baseUrl) {
        this.publicChannelVideos = new channel_videos_1.PublicChannelVideos(httpClient, baseUrl);
    }
    parseListChannelResponse(response, sort) {
        return Object.assign(Object.assign({}, response), { data: _.map(response.data.items, video_item_1.parseVideoItem), sort, paging: {
                size: response.data.items.length,
                cursor: response.data.cursor,
            } });
    }
    parseChannelVideoResponse(response) {
        return Object.assign(Object.assign({}, response), { data: (0, video_item_1.parseVideoItem)(response.data) });
    }
    listChannelVideos({ channelId, query, tag, category, mediaType, sort, paging, hydratedChannelVideos, templateMetaSiteId, }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const response = hydratedChannelVideos ||
                    (yield this.publicChannelVideos.getList({
                        channelId,
                        query,
                        tag,
                        category,
                        mediaType,
                        sort,
                        paging,
                        templateMetaSiteId,
                    }));
                return this.parseListChannelResponse(response, sort);
            }
            catch (error) {
                return (0, to_error_1.toError)(error);
            }
        });
    }
    getChannelVideoById(channelId, videoId, { hydratedVideo, templateMetaSiteId, } = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const response = hydratedVideo ||
                    (yield this.publicChannelVideos.getChannelVideoById(channelId, videoId, {
                        params: {
                            metaSiteId: templateMetaSiteId,
                        },
                    }));
                return this.parseChannelVideoResponse(response);
            }
            catch (error) {
                return (0, to_error_1.toError)(error);
            }
        });
    }
}
exports.PublicChannelVideosService = PublicChannelVideosService;
//# sourceMappingURL=channel-videos.js.map